@if (device) {
  <div class="row">
    @if (!deleting && !forceDeleting) {
      <div class="col-lg-12">
        <!--Move NFC tag-->
        @if (checkDeviceType('moveNFC')) {
          <div class="row mb-2" #ctrlElement>
            <div class="col-lg-12">
              <strong>{{ "MOVE_NFC_TAG" | translate }}</strong>
              <p>{{ "MOVE_NFC_TAG_INFO" | translate }}</p>
              <div class="form-group">
                <button
                  class="btn btn-primary mr-3"
                  [disabled]="selectedBasestation.length === 0"
                  (click)="moveNfcTag()"
                  >
                  <span class="fa-solid fa-arrow-left-long-to-line"></span>
                  {{ "MOVE" | translate }}
                </button>
                @if (basestationSelect.options.length > 0) {
                  <ngx-bootstrap-multiselect
                    [options]="basestationSelect.options"
                    [settings]="basestationSelect.settings"
                    [texts]="basestationSelect.texts"
                    [(ngModel)]="selectedBasestation"
                  ></ngx-bootstrap-multiselect>
                }
              </div>
              <div>
                @if (nfcMoveSuccess) {
                  <div class="alert alert-success" role="alert">
                    {{ "NFC_MOVE_SUCCESS" | translate }}
                  </div>
                }
                @if (nfcMoveError) {
                  <div class="alert alert-danger" role="alert">
                    {{ "NFC_MOVE_ERROR" | translate }}
                  </div>
                }
              </div>
              <hr />
            </div>
          </div>
        }
        <!--Replace device-->
        @if (checkDeviceType('replace') && (Areas.Devices | can: 'ReadWrite')) {
          <div class="row mb-2" #ctrlElement>
            <div class="col-lg-12">
              <strong>{{ "DEVICE_REPLACE_HEADER" | translate }}</strong>
              @if (!isReplaced) {
                <p>
                  {{ "DEVICE_REPLACE_INFO" | translate }}
                </p>
              }
              @if (isReplaced && device.deviceType !== '31-13') {
                <p>
                  {{ "DEVICE_REPLACE_INFO_CANCEL" | translate }}
                </p>
              }
              <div class="form-inline mb-2">
                <div class="form-group mr-2">
                  <input
                    type="text"
                    [attr.disabled]="isReplaced ? '' : null"
                    class="form-control"
                    placeholder="ID"
                    [(ngModel)]="replaceDevice"
                    />
                  </div>
                  <div class="form-group">
                    @if (!isReplaced) {
                      <button
                        type="button"
                        class="btn btn-outline-primary gray-bg"
                        (click)="deviceInventoryEnabled ? openReplaceDialog() : submitReplaceDevice()"
                        >
                        <span class="fa-light fa-fw fa-arrow-right-arrow-left"></span>
                        {{ "DEVICE_REPLACE" | translate }}
                      </button>
                    }
                    @if (isReplaced && device.deviceType !== '31-13') {
                      <button
                        type="button"
                        class="btn btn-outline-danger"
                        [disabled]="cancelling"
                        (click)="cancelReplace()"
                        >
                        <span [ngClass]="cancelling ? 'fad fa-spinner-third fa-spin mr-1' : 'fa-light fa-ban fa-fw'"></span>
                        {{ (cancelling ? "CANCELLING" : "CANCEL") | translate }}
                      </button>
                    }
                  </div>
                </div>
                @if (replaceError) {
                  <div class="alert alert-danger col-lg-6">
                    {{ replaceError }}
                  </div>
                }
                <hr />
              </div>
            </div>
          }
          <!--Manual Door ID Override (PL-151SA)-->
          @if (checkDeviceType('overrideDoorId')) {
            <div class="row mb-2" #ctrlElement>
              <div class="col-lg-12">
                <strong>{{ "MANUAL_DOOR_ID_OVERRIDE" | translate }}</strong>
                <p>{{ "MANUAL_DOOR_ID_OVERRIDE_DESC" | translate }}</p>
                <div class="form-inline mb-2">
                  <div class="form-group mr-2">
                    <input
                      type="number"
                      min="1"
                      max="254"
                      class="form-control"
                      [placeholder]="currentDoorId ?? 'ID'"
                      [(ngModel)]="doorIdOverride"
                    />
                  </div>
                  <div class="form-group">
                    <button
                      type="button"
                      class="btn btn-outline-primary gray-bg"
                      [disabled]="!doorIdOverride || +doorIdOverride < 1 || +doorIdOverride > 254"
                      (click)="openOverrideDoorIdDialog()"
                    >
                       <span class="fa-light fa-fw fa-arrow-right-arrow-left"></span>
                        {{ "CHANGE" | translate }}
                    </button>
                  </div>
                </div>
                @if (overrideDoorIdError) {
                  <div class="alert alert-danger col-lg-6">
                    {{ overrideDoorIdError }}
                  </div>
                }
                @if (overrideDoorIdSuccess) {
                  <div class="alert alert-success col-lg-6">
                    {{ "DOOR_ID_OVERRIDE_SUCCESS" | translate }}
                  </div>
                }
                <hr />
              </div>
            </div>
          }
          <!--Delete device-->
          @if (!checkDeviceType('forceDelete') && canDeleteDevice && checkDeviceType('everwatchDelete') && checkDeviceType('nightowlDelete')) {
            <div
              class="row mb-2"
              #ctrlElement
              [hidden]="toBeDeleted && user.roleLevel >= 200"
              >
              <div class="col-lg-12">
                <div>
                  <strong>{{ "DEVICE_DELETE_HEADER" | translate }}</strong>
                  @if (device.toBeDeleted) {
                    <p>
                      {{ "DEVICE_MARKED_DELETE" | translate }}
                    </p>
                  }
                  @if (!device.toBeDeleted) {
                    <p>
                      {{ "DEVICE_DELETE_INFORMATION" | translate }}
                    </p>
                  }
                  <button
                    [disabled]="device.toBeDeleted"
                    class="btn btn-outline-danger"
                    (click)="deleteDevice()"
                    >
                    <span class="fa-light fa-octagon-minus"></span>
                    {{ "UNPAIR" | translate }}
                  </button>
                </div>
              </div>
            </div>
          }
          <!--Force delete device-->
          @if (checkDeviceType('forceDelete') && canDeleteDevice && checkDeviceType('everwatchDelete') && checkDeviceType('nightowlDelete')) {
            <div class="row mb-2" #ctrlElement>
              <div class="col-lg-12">
                <div>
                  <strong>{{ "FORCE_DELETE" | translate }}</strong>
                  <p>{{ "DEVICE_FORCE_DELETE_INFORMATION" | translate }}</p>
                  <button class="btn btn-outline-danger" (click)="forceDeleteDevice()">
                    <span class="fa-light fa-octagon-minus"></span>
                    {{ "FORCE_DELETE" | translate }}
                  </button>
                </div>
              </div>
            </div>
          }
          <!--Cancel Deletion-->
          @if (toBeDeleted && user.roleLevel >= 200) {
            <div class="row mb-2">
              <div class="col-lg-12">
                <div>
                  <strong>{{ "CANCEL_TO_BE_DELETED" | translate }}</strong>
                  <p>
                    {{ "CANCEL_DELETE_INFORMATION" | translate }}
                  </p>
                  <button class="btn btn-outline-danger" (click)="revertDelete()">
                    <span class="fa-light fa-octagon-minus"></span>
                    {{ "CANCEL_DELETE" | translate }}
                  </button>
                </div>
              </div>
            </div>
          }
          <!--Retransfer settings or cancel settings transfers-->
          @if (checkDeviceType('rts') && (Areas.Devices | can: 'ReadWrite')) {
            <div class="row" #ctrlElement>
              <div class="col-lg-12">
                <hr />
                @if (device.tasksToBase === 0 && device.tasksFromBase === 0) {
                  <div>
                    <strong>{{ "DEVICE_RETRANSFER_SETTINGS" | translate }}</strong>
                    <p>{{ "DEVICE_RETRANSFER_INFORMATION" | translate }}</p>
                    <button class="btn btn-outline-primary" (click)="reTransferSettings()">
                      <span class="fa-light fa-down-to-line fa-lg"></span>
                      {{ "DEVICE_RETRANSFER_SETTINGS" | translate }}
                    </button>
                  </div>
                }
                @if (device.tasksToBase > 0 || device.tasksFromBase > 0) {
                  <div>
                    <strong>{{ "CANCEL_TRANSFERS" | translate }}</strong>
                    <p>{{ "CANCEL_TRANSFERS_INFORMATION" | translate }}</p>
                    <button class="btn btn-outline-primary" (click)="cancelSettingsTransfers()">
                      <span class="fa-light fa-xmark"></span>
                      {{ "CANCEL_TRANSFERS" | translate }}
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          <!--Ongoing firmware update, for users who may cancel it but not start one (starting is Everon internal)-->
          @if (!showFirmwareSection() && device.softwareUpdateOngoing && canCancelFirmwareUpdate) {
            <div class="row" #ctrlElement data-testid="firmware-cancel-section">
              <div class="col-lg-12">
                <hr />
                <strong>{{ "UPDATE_DEVICE_FIRMWARE" | translate }}</strong>
                <p>{{ "CURRENT_FIRMWARE" | translate }}: {{ device.softwareVersion }}</p>
                <p class="alert alert-info">
                  {{ "FIRMWARE_UPDATE_ONGOING" | translate }}
                  @if (device.swUdStartTime !== '00:00' || device.swUdEndTime !== '00:00') {
                    <span>({{ device.swUdStartTime }} - {{ device.swUdEndTime }})</span>
                  }.
                  {{ "WAIT_FOR_FIRMWARE_UPDATE" | translate }}
                </p>
                <button class="btn btn-outline-danger" (click)="cancelOTA()" data-testid="firmware-cancel">
                  <span class="fa-light fa-fw fa-xmark"></span>
                  {{ "CANCEL_UPDATE" | translate }}
                </button>
              </div>
            </div>
          }
          <!--Update device firmware-->
          @if (showFirmwareSection()) {
            <div class="row" #ctrlElement>
              <div class="col-lg-12">
                <hr />
                <strong>{{ "UPDATE_DEVICE_FIRMWARE" | translate }}</strong>
                <p>{{ "CURRENT_FIRMWARE" | translate }}: {{ device.softwareVersion }}</p>
                @if (device.softwareUpdateOngoing) {
                  <p class="alert alert-info">
                    {{ "FIRMWARE_UPDATE_ONGOING" | translate }}
                    @if (device.swUdStartTime !== '00:00' || device.swUdEndTime !== '00:00') {
                      <span>
                        ({{ device.swUdStartTime }} - {{ device.swUdEndTime }})
                      </span>
                      }.
                      {{ "WAIT_FOR_FIRMWARE_UPDATE" | translate }}
                    </p>
                  }
                  @if (firmwareVersions) {
                    <div>
                      <form
                        [formGroup]="otaUpdateForm"
                        (ngSubmit)="formSubmitSubject.next()"
                        [hidden]="device.softwareUpdateOngoing"
                        >
                        <div class="form-group">
                          <mat-form-field>
                            <mat-label>{{ "AVAILABLE_FIRMWARE_VERSIONS" | translate }}</mat-label>
                            <mat-select formControlName="fw">
                              @for (firmware of firmwareVersions; track firmware) {
                                <mat-option
                                  [ngClass]="{ testFirmware: !firmware.productionSw, recommendedFirmware: firmware.recommendedSw }"
                                  [style.color]="!firmware.productionSw ? '#E8413B' : null"
                                  [style.font-style]="!firmware.productionSw ? 'italic' : null"
                                  [style.font-weight]="firmware.recommendedSw ? 'bold' : null"
                                  [value]="firmware"
                                  >
                                  @if (!firmware.productionSw) {
                                    <span>
                                      {{ "NOT_FOR_PRODUCTION" | translate }} -
                                    </span>
                                  }
                                  {{ "REL" + firmware.swVersion }} - {{ firmware.description }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Show scheduled update times only for terminal devices and if firmware is selected -->
                        <div [hidden]="device.id.substring(0, 2) === '31' || !otaUpdateForm.value.fw">
                          <div class="form-group">
                            <mat-form-field>
                              <mat-label>{{ "OTA_UPDATE_TIMING" | translate }}</mat-label>
                              <mat-select formControlName="fwUpdateTiming">
                                <mat-option value="0">{{ "IMMEDIATELY" | translate }}</mat-option>
                                <mat-option value="1">{{ "DURING_TIMES" | translate }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="form-group">
                            @if (otaUpdateForm.value.fwUpdateTiming === '1') {
                              <div class="form-row">
                                <div class="col">
                                  <label>{{ "REPORT_START_TIME" | translate }}</label>
                                  <input
                                    class="form-control form-control-sm"
                                    [matTimepicker]="fwUpdateStartTime"
                                    formControlName="fwUpdateStartTime"
                                    />
                                    <mat-timepicker #fwUpdateStartTime interval="15m"></mat-timepicker>
                                  </div>
                                  <div class="col">
                                    <label>{{ "REPORT_END_TIME" | translate }}</label>
                                    <input
                                      class="form-control form-control-sm"
                                      [matTimepicker]="fwUpdateEndTime"
                                      formControlName="fwUpdateEndTime"
                                      />
                                      <mat-timepicker #fwUpdateEndTime interval="15m"></mat-timepicker>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="form-group">
                              <button type="submit" class="btn btn-outline-primary" [disabled]="!otaUpdateForm.valid">
                                <span class="fa-light fa-fw fa-arrows-rotate"></span>
                                {{ "UPDATE" | translate }}
                              </button>
                            </div>
                            <div class="form-group">
                              @if (otaError) {
                                <div class="alert alert-danger">
                                  {{ "ERROR" | translate }}
                                </div>
                              }
                              @if (otaSuccess) {
                                <div class="alert alert-success">
                                  {{ "FIRMWARE_UPDATE_SUCCESS" | translate }}
                                </div>
                              }
                            </div>
                          </form>
                          @if (device.softwareUpdateOngoing) {
                            <div>
                              <button class="btn btn-outline-danger" (click)="cancelOTA()">
                                <span class="fa-light fa-fw fa-xmark"></span>
                                {{ "CANCEL_UPDATE" | translate }}
                              </button>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Device delete confirmation -->
            @if (deleting || forceDeleting) {
              <div class="col-lg-12">
                @if (deleting) {
                  <strong>{{ "DEVICE_DELETE_CONFIRMATION" | translate : { devName: device.name ? device.name : device.id } }}</strong>
                }
                @if (forceDeleting) {
                  <strong>
                    {{ "DEVICE_FORCE_DELETE_CONFIRMATION" | translate : { devName: device.name ? device.name : device.id } }}
                  </strong>
                }
                @if (forceDeleting) {
                  <p>
                    {{ "DEVICE_FORCE_DELETE_CONFIRMATION_INFORMATION" | translate }}
                  </p>
                }
                @if (pairedDevices?.length > 0 && device.deviceType.startsWith('31')) {
                  <div>
                    {{ "DEVICE_DELETE_PAIRED" | translate }}:
                    <ul class="mt-2">
                      @for (pd of pairedDevices; track pd) {
                        <li>
                          {{ pd.name ? pd.name + ' - ' : '' }}{{ pd.id }}
                        </li>
                      }
                    </ul>
                  </div>
                }
                <div class="mt-2">
                  <button class="btn btn-outline-danger mr-1" (click)="confirmDelete()">
                    <span class="fa-light fa-octagon-minus"></span>
                    {{ "UNPAIR" | translate }}
                  </button>
                  <button class="btn btn-outline-primary" (click)="cancelDelete()">
                    <span class="fa-light fa-xmark"></span>
                    {{ "CANCEL" | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        }
